<!--
*@FxfaPage
*@author Ys
*@date 2023/1/10 11:08
-->
<template>
  <div style="margin-top: 35px;">
    <el-button type="primary"  style="position: absolute;right: 50px" @click="showKjfxRwList">查看记录</el-button>
    <div id="FirstDiv">
      <div class="contentDiv">
        <div id="contentTitle" >选择分析方案</div>
        <el-row class="containerDiv" style="width: 90%;height: 431px">
          <el-col :span="8" v-for="(item,i) in fxfaList" :key="item.id"  :style="{backgroundColor:item.value}" >
            <div id="fxfaBody" style="height: 400px;position: relative;overflow: hidden;" @click="checkFxfaAction(item.name)">
              <div class="containerDiv">
                <div v-html="item.iconFont"></div>
                <p style="color: white;font-size: 23px;line-height: 45px">{{item.name}}</p>
                <p style="width: 350px;color: #ecf5ff">{{item.des}}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import API from '../../../../api/ApiConfig'
  import {ajaxPost} from '../../../../util/AjaxhttpRequest'
  import $ from 'jquery'
  import Cookie from 'cookies-js'
  export default {
    name: 'FxfaPage',
    props: [],
    components: {},
    data () {
      return {
        fxfaList:[],
      }
    },
    mounted () {
      this.getFxfaList();
    },
    methods: {
      showKjfxRwList(){
        this.$emit('showRwList');
      },
      checkFxfaAction(fxfa){
        this.$emit('checkFxfa',fxfa)
      },
      getFxfaList(){
        ajaxPost(API.KjfxCommonProvider,"getDicList",[Cookie.get("wwJcptToken"),JSON.stringify(["分析方案"])]).then(result=>{
          this.fxfaList= JSON.parse(result)
        }).catch(err=>{
          this.$message.error(err);
        })
      }
    },
  }
</script>

<style scoped>

  #FirstDiv{
    position: absolute; left: 50%; top: 60%;transform: translate(-50%, -50%);overflow: auto;
    border-color: rgb(187, 187, 187);
    border-width: 1px;
    border-style: solid;
  }
  #contentTitle{
    border: 1px solid rgb(187, 187, 187);
    font-family:  SourceHanSansSC;
    font-weight: 400;
    font-size: 28px;
    background: rgb(234, 234, 234);
    color: rgb(16, 16, 16);
    font-style: normal;
    letter-spacing: 0;
    line-height: 40px;
    text-decoration: none;
  }
  .contentDiv{
    width: 1279px;
    height: 534px;
    font-size: 14px;
    padding: 0px;
    text-align: center;
    line-height: 20px;
    font-weight: normal;
    font-style: normal;
    background: rgb(255, 255, 255);
  }
  .containerDiv{
    position: absolute; left: 50%; top: 50%;
    transform: translate(-50%, -50%);
  }
  .icon{
    width: 128px;
    height: 128px;
  }
  #fxfaBody:hover, #fxfaBody:hover{
    opacity: 0.6;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/kjfx/main/components/FxfaPage.vue